import React, { FC } from 'react';
import { SvgIcon } from '../../SvgIcon/SvgIcon';

interface GoBackButtonProps {
  onClick: () => void;
  buttonLabel?: string;
}

export const GoBackButton: FC<GoBackButtonProps> = (props) => {
  const { onClick, buttonLabel = "Tilbake" } = props;

  return (
    <button onClick={onClick} type="button" className="GoBackButton">
      <SvgIcon iconName="arrow-left" className="GoBackButton__icon" hideFromScreenReaders />
      {buttonLabel}
    </button>
  )
};
